import { useMutation, useQueryClient } from '@tanstack/react-query';
import useScimSystem from '../systems/useScimSystem';
import { QueryKeys } from './keysAndFilters';

type Params = {
	workspaceID: number;
	onSuccess?: ( token: string ) => void;
	onError?: ( error: unknown ) => void;
};

const useGenerateScimTokenMutation = ( { workspaceID, onSuccess, onError }: Params ) => {
	const system = useScimSystem();
	const queryClient = useQueryClient();

	return useMutation(
		() => system.generateScimToken( { workspaceID } ),
		{
			onSuccess: ( token ) => {
				queryClient.invalidateQueries( QueryKeys.forScimToken( { workspaceID } ) );
				onSuccess?.( token );
			},
			onError
		}
	);
};

export default useGenerateScimTokenMutation;
